import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Card } from 'component/Card'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'

function renderSize(size: number, title: string, description: string) {
  return <Card gap={16} pad={8} tertiary opposite>
    <Vertical pad={[0, 4]}>
      <Typo size={opt.tsum ? 15 : 12} medium>{title}</Typo>
      <Typo size={12} secondary>{description}</Typo>
    </Vertical>
    <Space panel center width={opt.tsum ? 48 : 40} height={40}>
      <Typo size={opt.tsum ? 20 : 16} bold>{size}</Typo>
    </Space>
  </Card>
}

export const SizesStep = observer(() => {
  const onCancel = useLatestCallback(async () => {
    store.profile.step = 'profile'
  })

  return <Banner title={i18n('HowToChooseLegLength')} onCancel={onCancel}>
    <Typo size={15} secondary>{i18n('HowToChooseLegLengthDescription')}</Typo>
    <Gap height={24} />
    <Vertical gap={12}>
      {renderSize(28, i18n('Size28Title'), i18n('Size28Description'))}
      {renderSize(30, i18n('Size30Title'), i18n('Size30Description'))}
      {renderSize(32, i18n('Size32Title'), i18n('Size32Description'))}
      {renderSize(34, i18n('Size34Title'), i18n('Size34Description'))}
      {renderSize(36, i18n('Size36Title'), i18n('Size36Description'))}
    </Vertical>
    <Gap height={24} />
    <Button large text={!opt.tsum} action={onCancel}>
      {i18n('GoBack')}
    </Button>
  </Banner>
})
